import React, {useState, useEffect, useRef} from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { collection,  getDocs, updateDoc, doc, deleteDoc} from "firebase/firestore"; 
import { useNavigate } from 'react-router-dom';
import { db } from "../firebase-config";
import { AiFillEdit } from "react-icons/ai"
import { IoMdClose } from "react-icons/io"
import { useForm } from "react-hook-form";
import "../styles/components/loader.css"

const OfferDetails = () => {

    const navigate = useNavigate();

    const editRef = useRef()

    const [offers, setOffers] = useState([])
    const [ThisOffer, setThisOffer] = useState("");
    const [loadingState, setLoadingState] = useState(false)
    const [loadedDatas, setLoadedDatas] = useState(false)
    const [editionMode, setEditionMode] = useState(false)
    const [modalState, setModalState] = useState(false)
    const [submitionError, setSubmitionError] = useState(false)
    const [erasedState, setErasedState] = useState(false)
    const [editSuccess, setEditSuccess] = useState(false)
 
    const [count, setCount] = useState(); 
    const [countSkill, setCountSkill] = useState(); 

    useEffect(() =>  {
        setOffers([]);
        loadOfferData();
    }, []);

    const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
        mode: 'onChange',
        defaultValues: "",
  })
    const [validation, setValidation] = useState("")
    const loadOfferData = async () =>  {
  
  
        const ref = collection(db, 'offreDemploi');
        const querySnapshot = await getDocs(ref)
        querySnapshot.forEach((doc) => {
         
            setOffers(offer => [doc.data(), ...offer])
           
        }) 
        setLoadedDatas(true)
    }

    useEffect(() => {
        loadParams()
            
    }, [loadedDatas])


        const { offerID } = useParams()
        console.log(offerID)
        
        const loadParams = async () => {
            setTimeout(() => {
                const ThisOffer = offers.find(offer => offer.ID == offerID)
                setThisOffer(ThisOffer)
                
                console.log(ThisOffer)
        
            }, 1000)
           
        }
        
        useEffect(() => {
            setTimeout(() => {
                setLoadingState(true)
 
                console.log(loadingState)
                
            }, 5000)
        }, [loadParams])
        console.log(offers)

        const onEdit = async data  => {


            var structure = ThisOffer.STRUCTURE;     
            var contrat = ThisOffer.CONTRAT;
            var intitule = ThisOffer.INTITULE;
            var mission = ThisOffer.MISSION;
            var competences = ThisOffer.COMPETENCES;
            var conditions = ThisOffer.CONDITIONS;
            var contact = ThisOffer.CONTACT;
            
        
        
    
          function randomIntFromInterval(min, max) { // min and max included 
            return Math.floor(Math.random() * (max - min + 1) + min)
          }
          
          const autoGeneratedId = randomIntFromInterval(80, 1000)
    
    
        
                    
          if(data.contrat) {
            contrat = data.contrat
          } 
                    
          if(data.intitule) {
            intitule = data.intitule
          } 
          if(data.mission) {
            mission = data.mission
          } 
                    
          if(data.structure) {
            structure = data.structure.toUpperCase()
          } 
                    
          if(data.competences) {
            competences = data.competences
          } 
          if(data.conditions) {
            conditions = data.conditions
        
          } 
          if(data.contact) {
            contact = data.contact
    
          }
     
    
        try {
        
            
            const preSubInfo = {
              STRUCTURE: structure,
              CONTRAT: contrat,
              INTITULE: intitule,
              MISSION: mission,
              COMPETENCES: competences,
              CONDITIONS: conditions,
              CONTACT: contact,
            
             
            }

            var key = ThisOffer.ID + "-" + ThisOffer.STRUCTURE 
          
            console.log(preSubInfo)
            console.log(data)
            const ref = doc(db, "offreDemploi", key);
            const docRef = updateDoc(ref, preSubInfo)
          
         
            setValidation(["Votre offre a bien été enregistrée", "Success"])
  

          }
                  catch(err) {
                  console.log(err);
                  setValidation(["Une erreur s'est produite veuillez rééssayer ultérieurement", "Error"])
    
              }
          
              editRef.current.reset();
    
              
            }
            
            const eraseOffer = async () => {
                var key = ThisOffer.ID + "-" + ThisOffer.STRUCTURE 
                await deleteDoc(doc(db, "offreDemploi", key));
                setModalState(false)
                setErasedState(true)
            }

            const closeErase = () => {
                navigate("/")
            }
        return (
        <div>

            <button className='return' onClick={() =>  navigate("/")}>
                Retour
            </button>

           { modalState &&
        
            <div className='modal'>
                <div className="overlay">
                    <div className="modalBox">
                            <h3>Attention</h3>
                            <p>Cette action est irréversible, voulez-vous continuez ?</p>
                            <div className="buttons">
                            <button className="yes" onClick={eraseOffer}>Oui</button>
                            <button className="no" onClick={() => setModalState(false)}>Non</button>
                        </div>
                </div>
            </div>
                    
            </div>}
           { editionMode === true ? (
            <>
             {validation && <div className={ validation[1] === "Success" ? "success" : "error"}>{validation[0]}</div>}
            <div className="edition">

             <form  ref={editRef} id="sign-in" onSubmit={handleSubmit(onEdit)}>
                
             <IoMdClose  onClick={() => setEditionMode(false)}/>
                    
               
                <div className="field">
                    <label>Type de contrat</label>
                    <p><em>CDI, CDD, Contrat de mission... </em></p>
                    <input {...register('contrat')} type="text" name="contrat" id="" />
                </div>
                <div className="field">
                    <label>Intitulé du poste</label>
                    <input {...register('intitule')} type="text" name="intitule" id="" />
                </div>
                <div className="field">
                    <label>Mission</label>
                    <textarea {...register('mission')} name="mission"  maxLength="1000" cols="30" rows="5" onChange={e => setCount(e.target.value.length)} id=""></textarea>
                </div>
                <div className="counter">
                  <span class={count < 950 ? "green" : count === 1000 ? "red" : "orange"}>{count}</span>
                </div>
          
                <div className="field">
                    <label>Les compétences requises</label>
                    <p><em>savoir-faire, expériences, diplômes...</em></p>
                    <textarea {...register('competences')} name="competences" id="" maxLength="500" onChange={e => setCountSkill(e.target.value.length)} cols="30" rows="5"></textarea>
                </div>
                <div className="counter">
                    <span class={countSkill < 450 ? "green" : countSkill === 500 ? "red" : "orange"}>{countSkill}</span>
                </div>
                <div className="field">
                    <label>Conditions particulières</label>
                    <p><em>travail posté, astreintes, travail le samedi...</em></p>
                    <input {...register('conditions')} type="text" name="conditions" id="" />
                </div>
                <div className="field">
                    <label>Contact</label>
                    <p><em>adresse mail, téléphone ou site web permettant de candidater</em></p>
                    <input {...register('contact')} type="text" name="contact" id="" />
                </div>
             
             <button className="btn" id="button">Envoyer</button>
             </form>
            </div>
            </>
          )   :   
          <>
          { loadingState === true ? (

            <>
            {erasedState === false ? (

                <div className="offerWrapper">
                
                
                
                        <div className="offer">
                        <AiFillEdit  onClick={() => setEditionMode(true)}/>
                    
                        <h2>{ThisOffer.INTITULE}</h2>     
                        <h4>Organisme :</h4>     
                        <span>{ThisOffer.STRUCTURE}</span>
                        <h4>Type de Contrat : </h4>
                        <span>{ThisOffer.CONTRAT}</span> 
                        <div className="mission">
                            <h4>La Mission :</h4>  
                            <p>{ThisOffer.MISSION}</p>
                        </div>  
                        <h4>Compétences requises :</h4>     
                        <span>{ThisOffer.COMPETENCES}</span> 
                        <h4>Conditions Particulières : </h4>    
                        <span>{ThisOffer.CONDITIONS}</span> 
                        <h4>Contact : </h4>     
                        <span>{ThisOffer.CONTACT}</span><br />  
                        <button id="supp" onClick={() => setModalState(true)}>Supprimer l'offre</button>
                        </div>

                    </div>
                        ) :  
                        <div className='erased'>
                         <span>Votre offre à bien été supprimé !</span>
                        </div>
                    }
            </>
                ) : 
                <div className="loaderWrapper">
                <div className="loader"></div> 
                    
                </div>
        }

        </>
        }

        </div>
    );
};

export default OfferDetails;